// NidhiCompanyRegistration.jsx
import React from "react";

export default function NidhiCompanyRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for Nidhi Company Registration.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Nidhi Company
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Nidhi Company Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists with Nidhi Company Registration in
            compliance with MCA and Nidhi Rules, helping you set up a member‑
            based lending and deposit structure with proper legal recognition.
          </p>
          <p className="text-gray-700">
            From planning the company structure and preparing incorporation
            documents to handling filings and post‑incorporation requirements,
            the team supports promoters in building a compliant Nidhi Company
            focused on member savings and credit.
          </p>
        </div>

        {/* Right: Square Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/4968391/pexels-photo-4968391.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Team discussing Nidhi company registration and compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Nidhi Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps promoters and directors organize and
              validate the core documents required for a smooth Nidhi Company
              incorporation and early‑stage compliance.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  PAN and address proof of all proposed directors and initial
                  members.
                </li>
                <li>
                  Identity proof of directors and members (Aadhaar, passport,
                  voter ID, etc.).
                </li>
                <li>
                  Passport-size photographs and basic contact details of
                  directors and key members.
                </li>
                <li>
                  Registered office address proof (rent/lease agreement or
                  ownership proof, latest utility bill, and NOC from owner, if
                  applicable).
                </li>
                <li>
                  Draft incorporation documents, including Memorandum of
                  Association (MOA) and Articles of Association (AOA) with
                  Nidhi‑specific object clauses.
                </li>
                <li>
                  Any additional declarations or undertakings required under
                  Nidhi Rules and MCA forms, as applicable.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm combines Nidhi‑specific regulatory knowledge with
              practical experience in company formation, helping promoters
              manage both incorporation and subsequent compliance obligations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in Nidhi Regulations
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance tailored to Nidhi Rules and Companies Act
                  requirements, including membership norms, capital conditions,
                  and naming and object‑clause standards.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Compliance Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in preparing and filing incorporation forms and
                  related documents correctly, reducing the risk of MCA queries
                  or rejections.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Service Delivery
                </h3>
                <p className="text-gray-700 text-sm">
                  End‑to‑end assistance from initial planning and document
                  collation to registration and early post‑incorporation
                  compliance, with responsive professional support.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
